@let organizationsEc = organizationsEcSg();

<atn-ds-page>
  <atn-ds-page-header
    pageHeader
    [name]="pageNameSg()"
  >
    <div
      selectors
      class="atn-space-organizations__header-selectors"
    >
      <atn-ds-select-single
        [items]="orgEntitySelectItems()"
        [value]="selectedOrgEntityIdSg()"
        [required]="true"
        (valueChange)="selectedOrgEntityIdSg.set($event)"
      />
    </div>
  </atn-ds-page-header>
  @if (organizationsEc) {
    @if (tableConfigSg(); as tableConfig) {
      <atn-ds-table [config]="tableConfig" />
    }
  }
</atn-ds-page>

@if (organizationsEc && isUpdatingJointUseSg()) {
  <atn-space-joint-use-modal [organizationsEc]="organizationsEc" />
}
